import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'environments/environment';

@Pipe({
    name: 'imagePath',
})
export class ImagePathPipe implements PipeTransform {
    transform(fileName: string): string {
        if (!fileName) {
            return '';
        }

        if (/^(https?:)?\/\//.test(fileName) || fileName.startsWith('data:')) {
            return fileName;
        }

        const domain = environment.domainType;
        const cdnUrl = domain == 'dev' ? environment.dev_bunnycdn_url : environment.io_bunnycdn_url;
        return cdnUrl + 'assets/images/' + fileName;
    }
}
